import React, { useState } from "react";
import DropdownChoice from "./DropdownChoice";

import avenida from "../images/avenida.jpeg";
import baxiFerrol from "../images/Baxi_ferrol.jpeg";
import barcaCBS from "../images/Barca_cbs.jpeg";
import cadilaseu from "../images/sedi.jpeg";
import zaragoza from "../images/zaragoza.jpeg";
import celtaZorka from "../images/celta_zorka.jpeg";
import duran from "../images/duran_ensino.jpeg";
import pajariel from "../images/pajariel.jpeg";
import jairis from "../images/jairis_global.jpeg";
import idk from "../images/idk.jpeg";
import kutxa from "../images/kutxabanl.jpeg";
import lointek from "../images/lointek.jpeg";
import movistart from "../images/movistar.jpeg";
import spar from "../images/spar.jpeg";
import sparGran from "../images/spar_gran_canaria.jpeg";
import valencia from "../images/valencia_bc.jpeg";

import { Teams } from "../types/data";

interface Props {
  homeTeam: number;
  awayTeam: number;
  setHomeTeam: (team: number) => void;
  setAwayTeam: (team: number) => void;
  disabled: boolean;
}

const Dropdown: React.FC<Props> = ({
  homeTeam,
  awayTeam,
  setHomeTeam,
  setAwayTeam,
  disabled
}) => {
  const [isOpenHome, setIsOpenHome] = useState(false);
  const [isOpenAway, setIsOpenAway] = useState(false);

  const toggleDropdownHome = () => {
    setIsOpenHome(!isOpenHome);
  };

  const toggleDropdownAway = () => {
    setIsOpenAway(!isOpenAway);
  };

  console.log(disabled)

  return (
    // alert if disabled and clicked
    <div onClick={() => {if (disabled) alert("Please wait for the prediction to finish")}} className={!disabled ? "mx-5 my-2 bg-neutral-400 shadow-lg rounded-lg w-full" : "mx-5 my-2 bg-neutral-400 opacity-50 shadow-lg rounded-lg w-full"}>
    <div className="w-full" style={{pointerEvents: disabled ? "none" : "auto"}}>
      <div className="px-6 py-4 w-full flex flex-row">
        <div className="w-full flex flex-row">
          <div className="text-center text-lg font-bold w-32">Home Team</div>
          <div className="relative inline-block text-left flex-grow">
            <button
              type="button"
              onClick={toggleDropdownHome}
              className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100"
            >
              <span>{Teams[homeTeam].name}</span>
              <svg
                className={`-mr-1 h-5 w-5 text-gray-400 ${
                  isOpenHome ? "-rotate-180" : "rotate-0"
                }`}
                viewBox="0 0 20 20"
                fill="black"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            {isOpenHome && (
              <div className="absolute origin-top-right absolute right-0 mt-2 w-full z-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5" style={{pointerEvents: disabled ? "none" : "auto"}}>
                <p>{disabled}</p>
                <div
                  className="py-1"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  {/* Dropdown items */}
                  {Teams.map((item) => (
                    <DropdownChoice
                      src={item.picture}
                      name={item.name}
                      id={item.id}
                      onClick={setHomeTeam}
                      closePopup={setIsOpenHome}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="px-6 text-center text-lg font-bold w-32">VS</div>
        <div className="w-full flex flex-row">
          <div className="relative inline-block text-left flex-grow">
            <button
              type="button"
              onClick={toggleDropdownAway}
              className="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-100"
            >
              <span>{Teams[awayTeam].name}</span>
              <svg
                className={`-mr-1 h-5 w-5 text-gray-400 ${
                  isOpenAway ? "-rotate-180" : "rotate-0"
                }`}
                viewBox="0 0 20 20"
                fill="black"
                aria-hidden="true"
              >
                <path
                  fill-rule="evenodd"
                  d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            {/* Dropdown menu */}
            {isOpenAway && (
              <div className="origin-top-right absolute right-0 mt-2 w-full z-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                <div
                  className="py-1"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="options-menu"
                >
                  {/* Dropdown items */}
                  {Teams.map((item) => (
                    <DropdownChoice
                      src={item.picture}
                      name={item.name}
                      id={item.id}
                      onClick={setAwayTeam}
                      closePopup={setIsOpenAway}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
          <div className="text-center text-lg font-bold w-32">Away Team</div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default Dropdown;
